export const SESSION_STATUS = {
    QUEUE: 0,
    ACTIVE: 1,
    CLOSED: 2,
    CANCELLED: 3,
};
